globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Statistics = appCustomerSpace.Controllers.Statistics || {};

appCustomerSpace.Controllers.Statistics.BlogController = (function(superClass) {

  utils.extend(BlogController, superClass);

  function BlogController() {
    return BlogController.__super__.constructor.apply(this, arguments);
  }

  $.extend(BlogController.prototype, {
    init: function(){
      new appCustomerSpace.Modules.Statistics();

      return BlogController.__super__.init.apply(this, arguments);
    }
  });

  return BlogController;
})(appCustomerSpace.Controllers.Statistics.MainController);
